// Crypto Wallets → Configuration → policy pages (SM-278). The old single
// Policies page (three pick-an-asset upsert cards side by side) became
// three sibling list pages — withdrawal / gas / collection — each with
// its own create + edit flow. This file is just the shared route shell;
// the pages live in the child routes.
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/wallet-ops/config/policies")({
  component: Outlet,
});
